var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"exc-label",class:_vm.classes,style:({ transform: ("translateY(" + _vm.translateY + ") translateX(" + _vm.translateX + ")") })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }